<template>
  <ul ref="chatList" tabindex="-1" class="messages__chat_list" :aria-label="chatListLabel">
    <li v-for="(chat, index) in chats" :key="chatLink(chat)" class="messages__chat_list__item">
      <router-link
        :ref="'link_' + index"
        :to="chatLink(chat)"
        :data-index="index"
        class="button button--menu_item"
        :tabindex="index === 0 ? 0 : -1"
        @keydown.down="moveFocusDown"
        @keydown.up="moveFocusUp"
      >
        <ChatListItem :chat="chat" />
      </router-link>
    </li>
  </ul>
</template>

<script>
import ChatListItem from './ChatListItem.vue'
import { isMemberChatScope, publicationChatPath, memberChatPath, CHAT_LIST_HASH } from './route_helpers'
import focusOnRouteChange from './focus_on_route_change'

export default {
  name: 'ChatList',
  components: { ChatListItem },
  mixins: [focusOnRouteChange('chatList', CHAT_LIST_HASH)],
  props: {
    chats: {
      type: Array,
      required: true
    }
  },
  computed: {
    chatListLabel() {
      let label1, label2
      if (isMemberChatScope(this.$route)) {
        label1 = this.i18n.$gettext('Publication list')
        label2 = this.i18n.$ngettext('%{count} publication', '%{count} publications', this.chats.length, {
          count: this.chats.length
        })
      } else {
        label1 = this.i18n.$gettext('Member list')
        label2 = this.i18n.$ngettext('%{count} member', '%{count} members', this.chats.length, {
          count: this.chats.length
        })
      }

      return `${label1}, ${label2}`
    }
  },
  methods: {
    moveFocus(e, shift) {
      const currentIndex = parseInt(e.target.dataset.index)
      const nextRef = this.$refs['link_' + (currentIndex + shift)]

      if (nextRef && nextRef[0]) {
        nextRef[0].$el.focus()
      }

      e.preventDefault()
    },
    moveFocusDown(e) {
      this.moveFocus(e, 1)
    },
    moveFocusUp(e) {
      this.moveFocus(e, -1)
    },
    chatLink(chat) {
      if (isMemberChatScope(this.$route)) {
        return publicationChatPath(this.$route, chat.partner.publication)
      } else {
        return memberChatPath(this.$route, chat.partner.member)
      }
    }
  }
}
</script>
